/*
| Loading skeletons for real data fetches — layout-shaped shimmer placeholders
| instead of a bare "…". The shimmer animation freezes to a static placeholder
| under prefers-reduced-motion (central kill switch in motion.css). Markup is
| static (no user data) so innerHTML is safe.
*/
export function skeletonRows(n = 8): string {
    const rows = Array.from({ length: n }, () => '<div class="pl-skeleton pl-skeleton-row"></div>').join('');
    return `<div class="pl-skeleton-wrap" aria-hidden="true">${rows}</div>`;
}

export function skeletonLines(n = 3): string {
    const lines = Array.from({ length: n }, () => '<div class="pl-skeleton pl-skeleton-line"></div>').join('');
    return `<div class="pl-skeleton-wrap" aria-hidden="true">${lines}</div>`;
}
